module.exports = __webpack_public_path__ + "header_two.f2f2de96e14a40255e93.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/assets/img/landing/header_two.jpg
// module id = ../../../../../src/assets/img/landing/header_two.jpg
// module chunks = 1